export default __webpack_public_path__ + "c164ef9.png";